import { http } from '../services';

class HomeService {
    async getInformacoesPessoaLogada() {
        return http.get('/index');
    }

    async getMenusPublicos() {
        return http.get('/index-publico');
    }
}

const homeService = new HomeService();
export default homeService;
